import React, { Component } from "react";
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label,
  Form
} from "semantic-ui-react";
import "./custinfo.css";
class BillingInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listitems: [],
      list: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      newcontact: true
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.billingitems !== undefined && this.state.list.length === 0) {
      this.genbilling();
    }
    console.log(this.state.deletevalue);
  }
  componentDidMount() {
    if (this.props.billingitems !== undefined && this.state.list.length === 0) {
      this.genbilling();
    }
  }
  genbilling() {
    this.props.billingitems.map(item => {
      let lst = this.state.list;
      let itemtext =
        item.id + " - " + item.companyname1 + " - " + item.companyname2;
      let newitem = {
        key: item.id,
        value: item,
        text: itemtext
      };
      console.log(newitem);
      lst.push(newitem);
      this.setState({ list: lst });
    });
  }
  handlesave() {
    if (this.state.newcontact) {
      this.props
        .create(this.state.editvalue)
        .then(res => this.setState({ newcontact: false, editvalue: res }));
    } else {
      this.props.handleupdateitems(
        this.state.editvalue,
        this.state.editvalue.id,
        "billing"
      );
    }
  }
  handledelete() {
    var deletepayload = [];
    this.state.deletevalue.map(dl => {
      let newtitle = dl.companyname1 + " - " + dl.companyname2;
      let newitem = {
        title: newtitle,
        id: dl.id
      };
      deletepayload.push(newitem);
    });
    console.log(deletepayload);
    this.props.handleDelete(deletepayload, "billing");
  }
  geneditform() {
    let customer = Object.assign({}, this.state.editvalue);
    var formtitle = "Edit:";
    if (this.state.newcontact === true) {
      formtitle = "Add Contact";
    }
    if (this.state.editing !== false) {
      return (
        <div>
          <Grid>
            <Grid.Column width={2}>
              <h3>{formtitle}</h3>
            </Grid.Column>
            <Grid.Column width={4}>
              <h4>{customer.companyname1}</h4>
            </Grid.Column>
            <Grid.Column width={4}>
              <h4>{customer.companyname2}</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Button
                id="billingsavebtn"
                color={this.state.newcontact ? "blue" : "green"}
                onClick={() => this.handlesave()}
              >
                {this.state.newcontact ? "Create Billing" : "Save"}
              </Button>
              <Button
                id="billingsavebtn"
                onClick={() => this.setState({ editing: false })}
              >
                Cancel
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />
          <Form>
            <Grid>
              <Grid.Column width={2} textAlign="center">
                <Label size="large">Billing Number: {"  " + customer.id}</Label>
              </Grid.Column>
              <Grid.Column width={10}>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Company Name"
                    value={customer.companyname1}
                    onChange={e => {
                      customer.companyname1 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Company Description"
                    value={customer.companyname2}
                    onChange={e => {
                      customer.companyname2 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Street Address"
                    value={customer.street1}
                    onChange={e => {
                      customer.street1 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={6}
                    label="City"
                    value={customer.city}
                    onChange={e => {
                      customer.city = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={3}
                    label="State"
                    value={customer.state}
                    onChange={e => {
                      customer.state = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={3}
                    label="Zip Code"
                    value={customer.zipcode}
                    onChange={e => {
                      customer.zipcode = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={3}
                    label="Mail Stop"
                    value={customer.mailstop}
                    onChange={e => {
                      customer.mailstop = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Divider />
                <Form.Group>
                  <Form.Input
                    width={8}
                    label="1st Purchasing Contact"
                    value={customer.purchdeptcontact1}
                    onChange={e => {
                      customer.purchdeptcontact1 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={4}
                    label="Phone #"
                    value={customer.phone1}
                    onChange={e => {
                      customer.phone1 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={4}
                    label="Fax #"
                    value={customer.fax1}
                    onChange={e => {
                      customer.fax1 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={4}
                    label="Email"
                    value={customer.email1}
                    onChange={e => {
                      customer.email1 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Divider />
                <Divider />
                <Form.Group>
                  <Form.Input
                    width={8}
                    label="2nd Purchasing Contact"
                    value={customer.purchdeptcontact2}
                    onChange={e => {
                      customer.purchdeptcontact2 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={4}
                    label="Phone #"
                    value={customer.phone2}
                    onChange={e => {
                      customer.phone2 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={4}
                    label="Fax #"
                    value={customer.fax2}
                    onChange={e => {
                      customer.fax2 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                  <Form.Input
                    width={4}
                    label="Email"
                    value={customer.email2}
                    onChange={e => {
                      customer.email2 = e.target.value;
                      this.setState({ editvalue: customer });
                    }}
                  />
                </Form.Group>
                <Divider />
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      );
    }
  }

  render() {
    var newcustomer = {
      id: "",
      companyname1: "",
      companyname2: "",
      street1: "",
      street2: "",
      city: "",
      state: "",
      zipcode: "",
      mailstop: "",
      purchdeptcontact1: "",
      phone1: "",
      fax1: "",
      email1: "",
      purchdeptcontact2: "",
      phone2: "",
      fax2: "",
      email2: ""
    };
    return (
      <div className="BillingInfo">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Contact to Edit</Label>

            <Dropdown
              placeholder="Conact"
              fluid
              search
              selection
              options={this.state.list}
              value={this.state.newcontact ? null : this.state.editvalue}
              onChange={(e, { value }) => {
                this.setState({
                  editvalue: value,
                  editing: true,
                  newcontact: false
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              color="blue"
              id="deletecontactbutton"
              onClick={() =>
                this.setState({
                  newcontact: true,
                  editing: true,
                  editvalue: newcustomer
                })
              }
            >
              <Icon name="plus" /> Contact
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select Contacts to Delete</Label>
            <Dropdown
              placeholder="Select Billing Contact to Delete"
              fluid
              search
              selection
              multiple
              options={this.state.list}
              onChange={(e, { value }) => {
                this.setState({ deletevalue: value });
              }}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              negative
              id="deletecontactbutton"
              onClick={() => this.handledelete()}
            >
              Delete
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />

        {this.geneditform()}
      </div>
    );
  }
}
export default BillingInfo;



// WEBPACK FOOTER //
// ./src/components/customerinfo/billing.js